import httpRequest from "@/auth/http-client";
import { IRenew, IRenewInput, IRenewTotal } from "@/interfaces/renew.interfaces";

class RenewService {
  private baseUrl = "api/v1/subscribe/renew";

  async createRenew(renewData: IRenewInput): Promise<IRenew> {
    return await httpRequest.post(this.baseUrl, renewData);
  }

  async getById(renewId: number): Promise<IRenewTotal> {
    return await httpRequest.get(`${this.baseUrl}/total?customerSalesProductId=${renewId}`);
  }
}

const renewService = new RenewService();
export default renewService;
